var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 9.49334C19.3339 9.40561 19.317 9.31863 19.2839 9.23741C19.2507 9.15618 19.2018 9.0823 19.14 9.02001L16.3133 6.19334C16.2511 6.13156 16.1772 6.08267 16.096 6.0495C16.0147 6.01632 15.9278 5.9995 15.84 6.00001C15.7523 5.9995 15.6653 6.01632 15.5841 6.0495C15.5029 6.08267 15.429 6.13156 15.3667 6.19334L13.48 8.08001L6.19334 15.3667C6.13156 15.429 6.08267 15.5028 6.0495 15.5841C6.01632 15.6653 5.9995 15.7523 6.00001 15.84V18.6667C6.00001 18.8435 6.07025 19.0131 6.19527 19.1381C6.3203 19.2631 6.48987 19.3333 6.66668 19.3333H9.49335C9.58663 19.3384 9.67994 19.3238 9.76723 19.2905C9.85451 19.2572 9.93382 19.2059 10 19.14L17.2467 11.8533L19.14 10C19.2009 9.9354 19.2504 9.86103 19.2867 9.78001C19.2931 9.72687 19.2931 9.67315 19.2867 9.62001C19.2898 9.58898 19.2898 9.55771 19.2867 9.52668L19.3333 9.49334ZM9.22001 18H7.33334V16.1133L13.9533 9.49334L15.84 11.38L9.22001 18ZM16.78 10.44L14.8933 8.55334L15.84 7.61334L17.72 9.49334L16.78 10.44Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.639284419a4adf7c0e3a1489e76e3f78.svg";
export { ForwardRef as ReactComponent };